<div id="main-container"
     class="main-container"
     [style.width]="mainWidth"
     [style.height]="mainHeight"
>
  <app-loader></app-loader>
  <router-outlet></router-outlet>

<!--  <div *ngIf="iosAlert" class="alert">-->
<!--    <p class="alert__title">Please open this link in Safari</p>-->
<!--    <p class="alert__sub-title">Chrome has limited camera functions</p>-->
<!--    <img class="alert__image" src="assets/img/safari.png" alt="safari logo">-->
<!--  </div>-->
</div>


